import { render, staticRenderFns } from "./ClinicConfig.vue?vue&type=template&id=b13233de"
import script from "./ClinicConfig.vue?vue&type=script&lang=js"
export * from "./ClinicConfig.vue?vue&type=script&lang=js"
import style0 from "./ClinicConfig.vue?vue&type=style&index=0&id=b13233de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports